/**
 * Fallback for blocks that aren't in the registry.
 *
 * Dev: shows the block name and data for debugging.
 * Production: throws an error — missing blocks must not silently disappear.
 */
export function MissingBlock({
  name,
  data,
}: {
  name: string;
  data: Record<string, unknown>;
}) {
  if (import.meta.env.DEV) {
    return (
      <div className="my-4 rounded-lg border-2 border-dashed border-yellow-50 bg-yellow-10 p-6">
        <div className="mb-2 flex items-center gap-2">
          <span className="rounded bg-yellow-50 px-2 py-0.5 text-xs font-bold text-charcoal">
            MISSING BLOCK
          </span>
          <code className="font-mono text-sm text-charcoal">{name}</code>
        </div>
        <details className="mt-2">
          <summary className="cursor-pointer text-sm text-gray-60">
            Show block data
          </summary>
          <pre className="mt-2 max-h-60 overflow-auto rounded bg-white p-3 text-xs">
            {JSON.stringify(data, null, 2)}
          </pre>
        </details>
      </div>
    );
  }

  // Production: render a visible placeholder instead of nothing.
  // This makes missing blocks obvious during QA rather than silently disappearing.
  console.error(`[BlockRenderer] Missing block: "${name}"`);
  return (
    <div className="my-4 rounded-lg border border-gray-4 bg-gray-7 p-8 text-center text-sm text-gray-60">
      <p>Section unavailable</p>
    </div>
  );
}
